import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appCapitalizeFirstLetter]"
})
export class CapitalizeFirstLetterDirective {

  constructor(private elementRef: ElementRef) { }

  @HostListener("keyup") onKeyPress() {
    this.elementRef.nativeElement.value = this.capitalizeFirstLetter(this.elementRef.nativeElement.value);
  }

  private capitalizeFirstLetter(text: string): string {
    if (text) {
      let firstLetter = text.substr(0, 1).toUpperCase();
      let rest = text.substr(1).toLowerCase();
      return firstLetter + rest;
    } else {
      return "";
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/shared/directives/capitalize-first-letter.directive.ts